import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import TransactionPageNone from '@/modules/transaction/views/TransactionPageNone.vue'
import TransactionListWithdraw from '@/modules/transaction/views/TransactionListWithdraw.vue'
import TransactionPageDeposit from '@/modules/transaction/views/TransactionPageDeposit.vue'
const baseRoute = OneNetworkConfig.baseRoutePath
const TransactionRouter: any[] = [
  {
    path: `${baseRoute}/transaction/history`,
    name: 'transaction-history',
    meta: {
      component: TransactionPageNone
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/transaction/deposit`,
    name: 'transaction-deposit',
    meta: {
      component: TransactionPageDeposit,
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/transaction/withdraw`,
    name: 'transaction-withdraw',
    meta: {
      component: TransactionListWithdraw,
    },
    component: PrivateRouter,
  },
]

export default TransactionRouter
